import React, { useEffect } from 'react';
import { applyPageSeo } from '../utils/seo';
import Contact from './Contact';

const ContactPage = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
    return applyPageSeo({
      title: 'Contact Us | Growmore IT Services Satara',
      description:
        'Contact Growmore IT Services in Satara for website, app, ERP, WhatsApp API and SEO projects. Call +91 73506 95792 or visit Near IT Park, Godoli.',
      keywords:
        'contact Growmore IT Services, IT company Satara phone, Growmore Satara address',
      path: '/contact'
    });
  }, []);

  return (
    <div className="pt-16 min-h-screen">
      <h1 className="sr-only">Contact Growmore IT Services Satara — Software &amp; IT Solutions Office</h1>
      <Contact />
    </div>
  );
};

export default ContactPage;
